import { IonCol, IonIcon, IonItem, IonRow, IonSelect, IonSelectOption } from "@ionic/react"
import { useEffect, useState } from "react"
import {star, starOutline} from 'ionicons/icons'
import AE2Input from "../../elements/AE2Input"

interface Props{
    setParentForm:Function
    formErrors:[errors:any,setErrors:Function]
}

const startingForm = {
totalGrossFloorArea : "",
totalGrossFloorArea_units : "",
totalGrossFloorArea_date : "",
percentOfficeCooled : "",
percentOfficeCooled_date : "",
percentOfficeHeated : "",
percentOfficeHeated_date : "",
hasComputerLab : "",
hasComputerLab_date : "",
hasDinningHall : "",
hasDinningHall_date : "",
numberOfRooms : "",
numberOfRooms_date : ""

}
const startErrors = {
totalGrossFloorArea : "GFA cannot be empty",
totalGrossFloorArea_units : "Units cannot be empty",
totalGrossFloorArea_date : "Date cannot be empty",
percentOfficeCooled : "",
percentOfficeCooled_date : "",
percentOfficeHeated : "",
percentOfficeHeated_date : "",
hasComputerLab : "",
hasComputerLab_date : "",
hasDinningHall : "",
hasDinningHall_date : "",
numberOfRooms : "",
numberOfRooms_date : ""
}

const Barracks: React.FC<Props> = ({setParentForm,formErrors}) => {

    const [form, setForm] = useState(startingForm)
    const [errors, setErrors] = formErrors
    const handleFormChange = (value:any,name:string) => {
        validate(name,value)
        setForm((prevState) => {
            return {
                ...prevState,
                [name]:value
            }
        } )
        setParentForm({...form, [name]:value},'form')

    }

    const handleError = (name:string,value:any) => {
        setErrors((prevState:any) => {
            return {
                ...prevState,
                [name]:value
            }
        } )

    }

    const getCurrentDate = () => {
        return new Date().getTime();
      };


    useEffect(()=>{
        setErrors((prevState:any) => {
            return {
                ...prevState,
                ...startErrors
            }
        } )
    }, [setErrors])

    const validate = (name:string, value:any) => {
        switch(name){
            case ('totalGrossFloorArea'):
                if (value === ''){
                    handleError('totalGrossFloorArea','Gross Floor Are Cannot be Empty')
                }
                else if (value < 0){
                    handleError('totalGrossFloorArea','GFA must be a positive number')
                }
                else {
                    handleError('totalGrossFloorArea','')
                }
                break;
            case ('totalGrossFloorArea_units'):
                if (value === ''){
                    handleError('totalGrossFloorArea_units','Select gfa units')
                }
                else {
                    handleError('totalGrossFloorArea_units','')
                }
                break;
            case ('totalGrossFloorArea_date'):
                if (value === ''){
                    handleError('totalGrossFloorArea_date','Date cannot be empty')
                }
                else if (new Date(value).getTime() > getCurrentDate()){
                    handleError('totalGrossFloorArea_date','Invalid Date')
                }
                else {
                    handleError('totalGrossFloorArea_date','')
                }
                break;
            case ('hasComputerLab'):
                if( value !== '' && form.hasComputerLab_date === ''){
                    handleError('hasComputerLab_date','Date cannot be empty')
                }
                if( value === '' && form.hasComputerLab_date === ''){
                    handleError('hasComputerLab_date','')
                }
                break;
            case ('hasComputerLab_date'):
                if (form.hasComputerLab !== ''){
                    if (value === ''){
                        handleError('hasComputerLab_date','Date cannot be empty')
                    }
                    else if (new Date(value).getTime() > getCurrentDate()){
                        handleError('hasComputerLab_date','Invalid Date')
                    }
                    else {
                        handleError('hasComputerLab_date','')
                    }
                }
                break;
            case ('hasDinningHall'):
                if( value !== '' && form.hasDinningHall_date === ''){
                    handleError('hasDinningHall_date','Date cannot be empty')
                }
                if( value === '' && form.hasDinningHall_date === ''){
                    handleError('hasDinningHall_date','')
                }
                break;
            case ('hasDinningHall_date'):
                if (form.hasDinningHall !== ''){
                    if (value === ''){
                        handleError('hasDinningHall_date','Date cannot be empty')
                    }
                    else if (new Date(value).getTime() > getCurrentDate()){
                        handleError('hasDinningHall_date','Invalid Date')
                    }
                    else {
                        handleError('hasDinningHall_date','')
                    }
                }
                break;
            case ('numberOfRooms'):
                if (value < 0){
                    handleError('numberOfRooms','Number of rooms must be positive')
                }
                else {
                    handleError('numberOfRooms','')
                }
                if( value !== '' && form.numberOfRooms_date === ''){
                    handleError('numberOfRooms_date','Date cannot be empty')
                }
                if( value === '' && form.numberOfRooms_date === ''){
                    handleError('numberOfRooms_date','')
                }
                break;
            case ('numberOfRooms_date'):
                if (form.numberOfRooms !== ''){
                    if (value === ''){
                        handleError('numberOfRooms_date','Date cannot be empty')
                    }
                    else if (new Date(value).getTime() > getCurrentDate()){
                        handleError('numberOfRooms_date','Invalid Date')
                    }
                    else {
                        handleError('numberOfRooms_date','')
                    }
                }
                break;
            case ('percentOfficeHeated'):

                if( value !== '' && form.percentOfficeHeated_date === ''){
                    handleError('percentOfficeHeated_date','Date cannot be empty')
                }
                else if( value === '' && form.percentOfficeHeated_date === ''){
                    handleError('percentOfficeHeated_date','')
                }
                else {
                    handleError('percentOfficeHeated','')
                }
                break;
            case ('percentOfficeHeated_date'):
                if (form.percentOfficeHeated !== ''){
                    if (value === ''){
                        handleError('percentOfficeHeated_date','Date cannot be empty')
                    }
                    if (new Date(value).getTime() > getCurrentDate()){
                        handleError('percentOfficeHeated_date','Invalid Date')
                    }
                    else {
                        handleError('percentOfficeHeated_date','')
                    }
                }
                break;
            case ('percentOfficeCooled'):

                if( value !== '' && form.percentOfficeCooled_date === ''){
                    handleError('percentOfficeCooled_date','Date cannot be empty')
                }
                else if( value === '' && form.percentOfficeCooled_date === ''){
                    handleError('percentOfficeCooled_date','')
                }
                else {
                    handleError('percentOfficeCooled','')
                }
                break;
            case ('percentOfficeCooled_date'):
                if (form.percentOfficeCooled !== ''){
                    if (value === ''){
                        handleError('percentOfficeCooled_date','Date cannot be empty')
                    }
                    if (new Date(value).getTime() > getCurrentDate()){
                        handleError('percentOfficeCooled_date','Invalid Date')
                    }
                    else {
                        handleError('percentOfficeCooled_date','')
                    }
                }
                break;
            default:
                break;
        }
    }

    return (
        <div className="text-dark-blue">
            <h1>Barracks Form</h1>
            <IonRow>
                <IonCol sizeLg="6" sizeXl="4">
                    <IonItem lines="none">
                        <AE2Input type="number" errorText={errors.totalGrossFloorArea}  value={form.totalGrossFloorArea} placeholder='GFA' onIonChange={e => (handleFormChange(e.detail.value!,'totalGrossFloorArea'))}>
                            <div slot="label"><IonIcon slot="start" ios={starOutline} md={star} /> Total Gross Floor Area:</div>
                        </AE2Input>
                    </IonItem>
                </IonCol>
                <IonCol sizeLg="6" sizeXl="4">
                    <IonItem lines="none">
                        <div style={{width:'100%'}}>
                        <IonSelect className={errors.totalGrossFloorArea_units === '' ? "valid":'invalid'} value={form.totalGrossFloorArea_units} interface='popover' placeholder='Units' onIonChange={e => (handleFormChange(e.detail.value!,'totalGrossFloorArea_units'))}>
                            <IonSelectOption value={'Square Feet'}>Square Feet</IonSelectOption>
                            <IonSelectOption value={'Square Meters'}>Square Meters</IonSelectOption>
                            <div slot="label"><IonIcon slot="start" ios={starOutline} md={star} /> Units:</div>
                        </IonSelect>
                        <div className="error-detail">{errors.totalGrossFloorArea_units}</div>
                        </div>
                    </IonItem>
                </IonCol>
                <IonCol sizeLg="6" sizeXl="4">
                    <IonItem lines="none">
                        <AE2Input type="date" errorText={errors.totalGrossFloorArea_date } value={form.totalGrossFloorArea_date} placeholder='Date' onIonChange={e => (handleFormChange(e.detail.value!,'totalGrossFloorArea_date'))}>
                        <div slot="label"><IonIcon slot="start" ios={starOutline} md={star} /> Current as of:</div>
                        </AE2Input>
                    </IonItem>
                </IonCol>
            </IonRow>
            <IonRow>
                <IonCol sizeLg="6" sizeXl="4">
                    <IonItem lines="none">
                        <div style={{width:'100%'}}>
                        <IonSelect className={errors.percentOfficeCooled === '' ? "valid":'invalid'}  value={form.percentOfficeCooled} interface='popover' placeholder='% Cooled' onIonChange={e => (handleFormChange(e.detail.value!,'percentOfficeCooled'))}>
                            <IonSelectOption>50% or more</IonSelectOption>
                            <IonSelectOption>Less than 50%</IonSelectOption>
                            <IonSelectOption>Not Cooled</IonSelectOption>
                            <div slot="label"><IonIcon slot="start" ios={starOutline} md={star} /> Percent Office Cooled:</div>
                        </IonSelect>
                        <div className="error-detail">{errors.percentOfficeCooled}</div>
                        </div>
                    </IonItem>
                </IonCol>
                <IonCol sizeLg="6" sizeXl="4">
                    <IonItem lines="none">
                        <AE2Input type="date" errorText={errors.percentOfficeCooled_date }  value={form.percentOfficeCooled_date} placeholder='Date' onIonChange={e => (handleFormChange(e.detail.value!,'percentOfficeCooled_date'))}>
                        <div slot="label"><IonIcon slot="start" ios={starOutline} md={star} /> Current as of:</div>
                        </AE2Input>
                    </IonItem>
                </IonCol>
            </IonRow>
            <IonRow>
                <IonCol sizeLg="6" sizeXl="4">
                    <IonItem lines="none">
                        <div style={{width:'100%'}}>
                        <IonSelect className={errors.percentOfficeHeated === '' ? "valid":'invalid'}  value={form.percentOfficeHeated} interface='popover' placeholder='% Heated' onIonChange={e => (handleFormChange(e.detail.value!,'percentOfficeHeated'))}>
                            <IonSelectOption>50% or more</IonSelectOption>
                            <IonSelectOption>Less than 50%</IonSelectOption>
                            <IonSelectOption>Not Heated</IonSelectOption>
                            <div slot="label"><IonIcon slot="start" ios={starOutline} md={star} /> Percent Office Heated:</div>
                        </IonSelect>
                        <div className="error-detail">{errors.percentOfficeHeated}</div>
                        </div>
                    </IonItem>
                </IonCol>
                <IonCol sizeLg="6" sizeXl="4">
                    <IonItem lines="none">
                        <AE2Input type="date" errorText={errors.percentOfficeHeated_date }  value={form.percentOfficeHeated_date} placeholder='Date' onIonChange={e => (handleFormChange(e.detail.value!,'percentOfficeHeated_date'))}>
                        <div slot="label"><IonIcon slot="start" ios={starOutline} md={star} /> Current as of:</div>
                        </AE2Input>
                    </IonItem>
                </IonCol>
            </IonRow>
            <IonRow>
                <IonCol sizeLg="6" sizeXl="4">
                    <IonItem lines="none">
                        <div style={{width:'100%'}}>
                        <IonSelect className={errors.hasComputerLab === '' ? "valid":'invalid'} labelPlacement="stacked" value={form.hasComputerLab} interface='popover' placeholder='Has Computer Lab?' onIonChange={e => (handleFormChange(e.detail.value!,'hasComputerLab'))}>
                            <IonSelectOption>Yes</IonSelectOption>
                            <IonSelectOption>No</IonSelectOption>
                            <div slot="label"><IonIcon slot="start" ios={starOutline} md={star} /> Does Property Have a Computer Lab?</div>
                        </IonSelect>
                        <div className="error-detail">{errors.hasComputerLab}</div>
                        </div>
                    </IonItem>
                </IonCol>
                <IonCol sizeLg="6" sizeXl="4">
                    <IonItem lines="none">
                        <AE2Input type="date" errorText={errors.hasComputerLab_date }  value={form.hasComputerLab_date} placeholder='Date' onIonChange={e => (handleFormChange(e.detail.value!,'hasComputerLab_date'))}>
                            <div slot="label"><IonIcon slot="start" ios={starOutline} md={star} /> Current as of:</div>
                        </AE2Input>
                    </IonItem>
                </IonCol>
            </IonRow>
            <IonRow>
                <IonCol sizeLg="6" sizeXl="4">
                    <IonItem lines="none">
                        <div style={{width:'100%'}}>
                        <IonSelect className={errors.hasDinningHall === '' ? "valid":'invalid'} labelPlacement="stacked"  value={form.hasDinningHall} interface='popover' placeholder='Has Dining hall?' onIonChange={e => (handleFormChange(e.detail.value!,'hasDinningHall'))}>
                            <IonSelectOption>Yes</IonSelectOption>
                            <IonSelectOption>No</IonSelectOption>
                            <div slot="label"><IonIcon slot="start" ios={starOutline} md={star} /> Does Property Have a Dining Hall?</div>
                        </IonSelect>
                        <div className="error-detail">{errors.hasDinningHall}</div>
                        </div>
                    </IonItem>
                </IonCol>
                <IonCol sizeLg="6" sizeXl="4">
                    <IonItem lines="none">
                        <AE2Input type="date" errorText={errors.hasDinningHall_date }  value={form.hasDinningHall_date} placeholder='Date' onIonChange={e => (handleFormChange(e.detail.value!,'hasDinningHall_date'))}>
                        <div slot="label"><IonIcon slot="start" ios={starOutline} md={star} /> Current as of:</div>
                        </AE2Input>
                    </IonItem>
                </IonCol>
            </IonRow>
            <IonRow>
                <IonCol sizeLg="6" sizeXl="4">
                    <IonItem lines="none">
                        <AE2Input type="number" errorText={errors.numberOfRooms }  value={form.numberOfRooms} placeholder='Computers' onIonChange={e => (handleFormChange(e.detail.value!,'numberOfRooms'))}>
                        <div slot="label"><IonIcon slot="start" ios={starOutline} md={star} /> Number of Rooms?</div>
                        </AE2Input>
                    </IonItem>
                </IonCol>
                <IonCol sizeLg="6" sizeXl="4">
                    <IonItem lines="none">
                        <AE2Input type="date" errorText={errors.numberOfRooms_date }  value={form.numberOfRooms_date} placeholder='Date' onIonChange={e => (handleFormChange(e.detail.value!,'numberOfRooms_date'))}>
                        <div slot="label"><IonIcon slot="start" ios={starOutline} md={star} /> Current as of:</div>
                        </AE2Input>
                    </IonItem>
                </IonCol>
            </IonRow>
            <IonItem><IonIcon slot="start" color="white" ios={starOutline} md={star} />Required for Energy Star Score</IonItem>
        </div>
    )
}

export default Barracks